// extracted by mini-css-extract-plugin
export default {"InfoPanelDefaultContent":"InfoPanel-module__InfoPanelDefaultContent___2hCx1"};